// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pd-1";
export var messageSideRight = "_pd-2";
export var subscribeToBackInStockBubbleContainer = "_pd-0";